import { render } from "./RegisterForm.vue?vue&type=template&id=3b8d7342"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
script.render = render

export default script